import React, { useState } from "react" // [CONTENÇÃO 2026-07-06] useEffect removido com o boot /auth/me — religar no fix-forward
import { BrowserRouter as Router, Routes, Route } from "react-router-dom"
import Home from "./pages/Home"
import Cadastro from "./pages/Cadastro"
import CadastroEncontrado from "./pages/Cadastro/Encontrado"
import Especialidade from "./pages/Especialidade"
import Unidade from "./pages/Unidade"
import Medico from "./pages/Medico"
import Agendamento from "./pages/Agendamento"
import Valor from "./pages/Valor"
import Confirmacao from "./pages/Confirmacao"
import Convenio from "./pages/Convenio"
import encryptClass from "./inc/Controllers/encrypt.class"
import Loader from "./pages/Global/Loader"
import ErrorPage from "./pages/Error"
import ProtectedRoute from "./components/ProtectedRoute"
// [CONTENÇÃO 2026-07-06] import de api removido com o boot /auth/me — religar no fix-forward
// import api from "./services/api"

import { GlobalContext } from "./contexts/global"

export default function SiteRoutes() {
  const [patientFound, setPatientFound] = useState(
    sessionStorage.getItem("patientFound")
  )
  const [statusSegmais, setStatusSegmais] = useState(
    sessionStorage.getItem("statusSegmais")
  )

  const [LoaderState, setLoaderState] = useState(false)

  // [CONTENÇÃO 2026-07-06] auth desativada — religar no fix-forward.
  // /auth/me está sem guard no backend e retorna SEMPRE 401, o que apagava patientFound
  // a cada boot (F5). Hidratação de sessão desligada no modo sem-auth.
  // --- BLOCO AUTH ORIGINAL (religar no fix-forward) ---
  // useEffect(() => {
  //   api.get("/auth/me").catch(err => {
  //     if (err && err.response && err.response.status === 401) {
  //       sessionStorage.removeItem("patientFound")
  //       setPatientFound(null)
  //       sessionStorage.removeItem("statusSegmais")
  //       setStatusSegmais(null)
  //     }
  //   })
  // }, [])
  // --- FIM BLOCO AUTH ORIGINAL ---

  var patient = patientFound
    ? JSON.parse(encryptClass.reveal(patientFound))
    : false

  return (
    <GlobalContext.Provider
      value={{
        statusSegmais,
        setStatusSegmais,
        patientFound,
        setPatientFound,
        LoaderState,
        setLoaderState
      }}
    >
      <Loader />
      <Router>
        <Routes>
          <Route exact path="/" element={<Home />} />
          <Route
            path="/cadastro"
            element={
              typeof patient !== "object" ? (
                <Cadastro />
              ) : (
                <CadastroEncontrado />
              )
            }
          />
          <Route path="/error" element={<ErrorPage />} />
          <Route
            path="/especialidade"
            element={
              <ProtectedRoute>
                <Especialidade />
              </ProtectedRoute>
            }
          />
          <Route
            path="/unidade"
            element={
              <ProtectedRoute>
                <Unidade />
              </ProtectedRoute>
            }
          />
          <Route
            path="/medico"
            element={
              <ProtectedRoute>
                <Medico />
              </ProtectedRoute>
            }
          />
          <Route
            path="/agendamento"
            element={
              <ProtectedRoute>
                <Agendamento />
              </ProtectedRoute>
            }
          />
          <Route
            path="/valor"
            element={
              <ProtectedRoute>
                <Valor />
              </ProtectedRoute>
            }
          />
          <Route
            path="/confirmacao"
            element={
              <ProtectedRoute>
                <Confirmacao />
              </ProtectedRoute>
            }
          />
          <Route path="/convenio" element={<Convenio />} />
        </Routes>
      </Router>
    </GlobalContext.Provider>
  )
}
